import React from 'react';
import { Conversation } from '@/widget/domain/conversation';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import cx from 'classnames';
import ConversationListItem from '@/widget/ui/components/conversations/ListItem';
import { ReactSVG } from 'react-svg';
import chevron from '@/widget/ui/images/chevron-right.svg';
import styles from './LastConversations.module.scss';

interface Props {
  conversations: Conversation[]
  openConversation: (key: string) => void;
}

function LastConversations({ conversations, openConversation }: Props) {
  const { store, settings } = useChatWidgetContext();
  const { color, host } = settings;
  const { setMode } = store.getState();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.caption}>
          {window.ChatWidget.i18n.t('chat_widget.lastConversations')}
        </div>
        <div
          className={styles.expand}
          onClick={() => setMode('list')}
        >
          {window.ChatWidget.i18n.t('chat_widget.expandAll')}
        </div>
      </div>
      <div className={cx(styles.bottom, styles.conversation)}>
        <ConversationListItem conversation={conversations[0]} openConversation={openConversation} />
        <div className={styles.chevron} style={{ color }}>
          <ReactSVG src={host + chevron} />
        </div>
      </div>
    </div>
  );
}

export default LastConversations;
